
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchantDetails/[id]",
      function () {
        return require("private-next-pages/merchantDetails/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchantDetails/[id]"])
      });
    }
  